import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from "ng2-translate";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FirebaseListObservable,
  AngularFireDatabase
} from 'angularfire2/database-deprecated';
import { Subscription } from 'rxjs';
import { MediaMatcher } from '@angular/cdk/layout';
import { UserService } from '../../_services/user.service';
@Component({
  selector: 'app-landing-brand',
  templateUrl: './landing-brand.component.html',
  styleUrls: ['./landing-brand.component.css']
})
export class LandingBrandComponent implements OnInit {
  private subscription: Subscription = new Subscription();
  brandName: string;
  brandRate: FirebaseListObservable<any[]>;
  brand: any;
  uniqueName: string;
  userId = this.userService.getUid();
  user: any;
  brandCategories: FirebaseListObservable<any[]>;
  model: any;
  mode: boolean;
  averageRate: any;
  categoryButtonText: any;
  mobileQuery: any;
  private _mobileQueryListener: () => void;
  constructor(private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    public translate: TranslateService,
    private media: MediaMatcher,
    private cd: ChangeDetectorRef,
    private cdr: ChangeDetectorRef) {
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user;
    }));
    this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');
    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.mode = this.route.snapshot.queryParams['mode'] == 3;
    this.subscription.add(this.route.params.subscribe(params => {
      const url = decodeURIComponent(this.router.url);
      if (url.indexOf("#") != -1) {
        this.brandName = params["uniqueName"].split("#")[0];
        this.uniqueName = (url.split("#")[0] || url.split("#")[0].split("/")[2]) + "/hashtags/" + url.split("#")[1];
      } else {
        this.brandName = this.uniqueName = params["uniqueName"];
      }


    }));
  }



  ngAfterViewInit() {
    this.cdr.detectChanges();
  }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/landing-brand/landing-brand.component.ts